import { render, staticRenderFns } from "./CmpWkqDetail.vue?vue&type=template&id=c078f980&scoped=true&"
import script from "./CmpWkqDetail.vue?vue&type=script&lang=js&"
export * from "./CmpWkqDetail.vue?vue&type=script&lang=js&"
import style0 from "./CmpWkqDetail.vue?vue&type=style&index=0&id=c078f980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078f980",
  null
  
)

export default component.exports